import { render, staticRenderFns } from "./logoutModal.vue?vue&type=template&id=381ad0f4&"
import script from "./logoutModal.vue?vue&type=script&lang=ts&"
export * from "./logoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./logoutModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports